(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer-bottom"]) return;
  try {
    
  (() => {
    document.querySelectorAll('[data-vang-back-top]').forEach((link) => {
      if (link.dataset.vangBackReady === 'true') return;
      link.dataset.vangBackReady = 'true';
      link.addEventListener('click', (event) => {
        event.preventDefault();
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vang-banner"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.querySelectorAll('[data-vang-banner-motion]').forEach((root) => {
      if (root.dataset.vangBannerReady === 'true') return;
      root.dataset.vangBannerReady = 'true';

      const finePointer = window.matchMedia('(hover: hover) and (pointer: fine)');
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      let frame = 0;
      let px = 0.5;
      let py = 0.5;

      const reset = () => {
        root.classList.remove('is-vang-banner-active');
        root.style.removeProperty('--vang-main-x');
        root.style.removeProperty('--vang-main-y');
        root.style.removeProperty('--vang-main-rx');
        root.style.removeProperty('--vang-main-ry');
        root.style.removeProperty('--vang-ghost-x');
        root.style.removeProperty('--vang-ghost-y');
        root.style.removeProperty('--vang-pointer-x');
        root.style.removeProperty('--vang-pointer-y');
      };

      const render = () => {
        frame = 0;
        const x = (px - 0.5) * 2;
        const y = (py - 0.5) * 2;
        root.style.setProperty('--vang-main-x', `${(x * 7).toFixed(2)}px`);
        root.style.setProperty('--vang-main-y', `${(y * 5).toFixed(2)}px`);
        root.style.setProperty('--vang-main-rx', `${(-y * 1.15).toFixed(2)}deg`);
        root.style.setProperty('--vang-main-ry', `${(x * 1.55).toFixed(2)}deg`);
        root.style.setProperty('--vang-ghost-x', `${(-x * 12).toFixed(2)}px`);
        root.style.setProperty('--vang-ghost-y', `${(-y * 9).toFixed(2)}px`);
        root.style.setProperty('--vang-pointer-x', `${(px * 100).toFixed(1)}%`);
        root.style.setProperty('--vang-pointer-y', `${(py * 100).toFixed(1)}%`);
      };

      root.addEventListener('pointerenter', () => {
        if (!finePointer.matches || reducedMotion.matches) return;
        root.classList.add('is-vang-banner-active');
      });

      root.addEventListener('pointermove', (event) => {
        if (!finePointer.matches || reducedMotion.matches) return;
        const rect = root.getBoundingClientRect();
        if (!rect.width || !rect.height) return;
        px = Math.min(Math.max((event.clientX - rect.left) / rect.width, 0), 1);
        py = Math.min(Math.max((event.clientY - rect.top) / rect.height, 0), 1);
        root.classList.add('is-vang-banner-active');
        if (!frame) frame = requestAnimationFrame(render);
      }, { passive: true });

      root.addEventListener('pointerleave', reset);
      finePointer.addEventListener?.('change', reset);
      reducedMotion.addEventListener?.('change', reset);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vang-home-styles"]) return;
  try {
    
  (() => {
    const initProjectTwo = () => {
      const works = document.querySelector('[data-vang-works]');
      const projectTwo = works?.querySelectorAll('[data-vang-work]')?.[1];
      if (!projectTwo || projectTwo.querySelector('a') || projectTwo.dataset.vangProjectTwoLink === 'true') return;

      projectTwo.dataset.vangProjectTwoLink = 'true';
      projectTwo.setAttribute('role', 'link');
      projectTwo.setAttribute('tabindex', '0');
      projectTwo.setAttribute('aria-label', 'Abrir Proyecto dos');

      const openProject = () => {
        window.location.href = '/pages/proyecto-dos';
      };

      projectTwo.addEventListener('click', openProject);
      projectTwo.addEventListener('keydown', (event) => {
        if (event.key !== 'Enter' && event.key !== ' ') return;
        event.preventDefault();
        openProject();
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initProjectTwo, { once: true });
    } else {
      initProjectTwo();
    }

    document.addEventListener('shopify:section:load', initProjectTwo);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vang-portfolio"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initVangWorks = (root) => {
      if (!root || root.dataset.vangWorksReady === 'true') return;
      root.dataset.vangWorksReady = 'true';

      const track = root.querySelector('[data-vang-works-track]');
      const cards = Array.from(root.querySelectorAll('[data-vang-work]'));
      if (!track || !cards.length) return;

      const mobile = window.matchMedia('(max-width: 749px)');
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      let revealObserver;
      let sectionObserver;

      const visibleCards = () => cards.filter((card) => window.getComputedStyle(card).display !== 'none');
      const revealAll = () => visibleCards().forEach((card) => card.classList.add('is-vang-visible'));

      const resetMobileStart = () => {
        if (!mobile.matches) return;
        requestAnimationFrame(() => {
          track.scrollLeft = 0;
          const firstCard = visibleCards()[0];
          firstCard?.classList.add('is-vang-visible');
        });
      };

      const stopObservers = () => {
        revealObserver?.disconnect();
        sectionObserver?.disconnect();
        revealObserver = null;
        sectionObserver = null;
      };

      const setupDesktopReveal = () => {
        revealObserver = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-vang-visible');
            revealObserver?.unobserve(entry.target);
          });
        }, {
          threshold: 0.12,
          rootMargin: '0px 0px -6% 0px'
        });

        visibleCards().forEach((card) => revealObserver.observe(card));
      };

      const setupMobileReveal = () => {
        sectionObserver = new IntersectionObserver((entries) => {
          if (!entries.some((entry) => entry.isIntersecting)) return;
          sectionObserver?.disconnect();
          sectionObserver = null;

          const mobileCards = visibleCards();
          mobileCards[0]?.classList.add('is-vang-visible');

          revealObserver = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
              if (!entry.isIntersecting) return;
              entry.target.classList.add('is-vang-visible');
              revealObserver?.unobserve(entry.target);
            });
          }, {
            root: track,
            threshold: 0.28,
            rootMargin: '0px -5% 0px 0px'
          });

          mobileCards.slice(1).forEach((card) => revealObserver.observe(card));
        }, { threshold: 0.1 });

        sectionObserver.observe(root);
      };

      const setupReveal = () => {
        stopObservers();
        if (reducedMotion.matches || !('IntersectionObserver' in window)) {
          revealAll();
          return;
        }

        const currentCards = visibleCards();
        currentCards.forEach((card) => card.classList.remove('is-vang-visible'));

        if (mobile.matches) {
          currentCards[0]?.classList.add('is-vang-visible');
          setupMobileReveal();
        } else {
          setupDesktopReveal();
        }
      };

      mobile.addEventListener?.('change', () => {
        setupReveal();
        resetMobileStart();
      });
      reducedMotion.addEventListener?.('change', setupReveal);
      setupReveal();
      resetMobileStart();
    };

    document.querySelectorAll('[data-vang-works]').forEach(initVangWorks);
    document.addEventListener('shopify:section:load', (event) => {
      const root = event.target?.querySelector?.('[data-vang-works]') || (event.target?.matches?.('[data-vang-works]') ? event.target : null);
      initVangWorks(root);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vang-scroll-statement"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const clamp = (number, minimum, maximum) => Math.min(Math.max(number, minimum), maximum);

    document.querySelectorAll('[data-vang-statement]').forEach((root) => {
      if (root.dataset.vangReady === 'true') return;
      root.dataset.vangReady = 'true';
      const letters = Array.from(root.querySelectorAll('[data-vang-letter]'));
      if (!letters.length) return;
      let ticking = false;

      const update = () => {
        ticking = false;
        const rect = root.getBoundingClientRect();
        const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
        const startLine = viewportHeight * 0.82;
        const endLine = viewportHeight * 0.22;
        const distance = Math.max(rect.height + startLine - endLine, 1);
        const progress = clamp((startLine - rect.top) / distance, 0, 1);

        letters.forEach((letter, index) => {
          const start = index / letters.length;
          const end = (index + 1) / letters.length;
          const localProgress = clamp((progress - start) / Math.max(end - start, 0.001), 0, 1);
          letter.style.opacity = String(0.16 + (0.84 * localProgress));
        });
      };

      const requestUpdate = () => {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(update);
      };

      update();
      window.addEventListener('scroll', requestUpdate, { passive: true });
      window.addEventListener('resize', requestUpdate);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
